import ErrorComponent from "@/components/atoms/ErrorComponent";
import CompanyCourseStatusHeader from "@/components/molecules/card-headers/companies/CompanyCourseStatusHeader";
import CompanyCourseStatusEditCard from "@/components/molecules/cards/companies/CompanyCourseStatusEditCard";
import { UUID_REGEX } from "@/constants/regexs";
import { FC } from "react";
import { useParams } from "react-router-dom";

const CompanyCourseStatusEditView: FC = () => {
  const { id } = useParams<{ id: string }>();

  if (!id || !UUID_REGEX.test(id)) {
    return (
      <ErrorComponent error={{ status: 404, data: {} }} absolute returnButton />
    );
  }

  return (
    <div className="formalys-page formalys-detail-page formalys-edit-page">
      <CompanyCourseStatusHeader id={id} isEdit />
      <CompanyCourseStatusEditCard id={id} />
    </div>
  );
};

export default CompanyCourseStatusEditView;
